// 美团APP
// 点评APP
import Url from '../utils/url';
var sourceType = Url.getQuery('sourceType') || Url.getHashQuery('sourceType');
var sellChannel = sourceType == 1 ? 34 : 2;
export default {
  appName: 'meituan',
  useKNB: true,
  sellChannel: sellChannel,
  theme: 'meituan'
};